// extracted by mini-css-extract-plugin
module.exports = {"root":"ClearentDisclaimer_root__hJ7EM","header":"ClearentDisclaimer_header__37jP9","inner":"ClearentDisclaimer_inner__1QqiA"};